<div [ngClass]="containerClass">
  @if (filters) {
    <div class="row">
      <!-- mobile filters -->
      <div class="col">
        <div class="filter-container filter-container-mobile" [ngClass]="filterWrapperClasses || []">
          @if (mobileFilter) {
            <ng-container *ngTemplateOutlet="filterTpl"></ng-container>
          }
        </div>
      </div>
    </div>
  }
  <div class="row scroll-container-wrapper">
    <!-- sticking filters -->
    @if (filters.length && stickyFilters) {
      <div class="col sticky-filter-container" [ngClass]="filterWrapperClasses || []">
        <ng-container *ngTemplateOutlet="filterTpl"></ng-container>
      </div>
    }

    <div class="col scroll-container-outer">
      <div class="row scroll-container" #scrollContainer>
        <!-- scrolling filters -->
        @if (filters.length && !stickyFilters) {
          <div class="filter-container filter-container-desktop" #navContainer [ngClass]="filterWrapperClasses || []">
            <ng-container *ngTemplateOutlet="filterTpl"></ng-container>
          </div>
        }
        <!--
        this element will show up in the dom but its supposed to be used sticky filters,
        so a placeholder card will be shown behind the filters to calculate the scroll position properly.
        -->
        <div class="mock-offset-card" [ngClass]="placeholderOffsetItemClasses || []"></div>

        <!--
        this card will not show itsetlf and is only meant to calculacte a generic offset to subsctract from
        the current calculated left position.
        -->
        <div class="offset-card" #offsetCard [ngClass]="offsetItemClasses || []"></div>

        @for (item of items; track item.id; let index = $index) {
          <div class="card-item-wrapper" #cardItem [ngClass]="itemWrapperClasses || []">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item, index: index }"></ng-container>
          </div>
        }
      </div>

      @if (canLeft) {
        <div class="gradient gradient-left" [@fadeInOut]></div>
        <div class="prev-btn" (click)="scrollPrev()" [@fadeInOut]>
          <div class="btn btn-round-l">
            <span class="mb-icon mb-icon-back"></span>
          </div>
        </div>
      }
      @if (canRight) {
        <div class="gradient gradient-right" [@fadeInOut]></div>
        <div class="next-btn" (click)="scrollNext()" [@fadeInOut]>
          <div class="btn btn-round-l">
            <span class="mb-icon mb-icon-forward"></span>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #filterTpl>
  @for (filter of filters; track filter.value; let index = $index) {
    <div
      class="filter-item"
      [class.active]="filter.active"
      [class.disabled]="filter.disabled"
      (click)="setFilter(filter)"
    >
      <span class="filter-item-label copy-l">
        {{ filter.label | translate }}
        @if (filter.count) {
          <span class="mb-badge mb-badge-xxs">{{ filter.count }}</span>
        }
      </span>
    </div>
  }
</ng-template>

@if (activeConfig.showNavigation && (canLeft || canRight)) {
  <mb-slider-navigation
    [length]="items.length - (activeConfig.navigationCap || 0)"
    [activeIndex]="activeIndex"
    (indexChange)="slideTo($event)"
    class="navigation"
  ></mb-slider-navigation>
}
